import React, { useState } from "react";
import PropTypes from 'prop-types';
import { getPrCommentText, getPrCommentAuthorName } from '../../../helpers/DataHelper';
import { getPrCommentDate } from "../../../helpers/DateHelper";
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { getPrComments } from '../../../services/apiServices';

const PrComments = ({ usersMetrics, platform }) => {
    const [show, setShow] = useState(false);
    const [prComments, setPrComments] = useState([]);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
        handlePrCountClick(usersMetrics["prIds"]);
    };

    const handlePrCountClick = async (prIds) => {
        let allPrComments = await getPrComments({ prIds: prIds });
        setPrComments(allPrComments)
    }

    return (
        <>
            {usersMetrics["totalPrComments"] > 0 && <Button variant="link" onClick={handleShow}>
                {usersMetrics["totalPrComments"]}
            </Button>}
            {usersMetrics["totalPrComments"] === 0 && <span>{usersMetrics["totalPrComments"]}</span>}
            <Offcanvas show={show} onHide={handleClose} placement="end" className="pr-comments-list-wrapper">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>All Comments on PRs for {usersMetrics["developer"]}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Comment</th>
                                <th>Reviewer</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {prComments.map((comment, index) => {
                                return (<tr key={usersMetrics + "_" + platform + "_" + index}>
                                    <td>{index + 1}</td>
                                    <td>{getPrCommentText(comment, platform)}</td>
                                    <td>{getPrCommentAuthorName(comment, platform)}</td>
                                    <td>{getPrCommentDate(comment, platform)}</td>
                                </tr>)
                            })}

                        </tbody>
                    </Table>


                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

PrComments.propTypes = {
    usersMetrics: PropTypes.object.isRequired,
    platform: PropTypes.string.isRequired
}

export default PrComments;